module.exports = __webpack_public_path__ + "static/media/preview.93d6587b.png";